import { useEffect } from 'react';
import { usePostHog } from '@posthog/react';
import { useServices } from '@/infrastructure/providers/ServiceProvider';

/**
 * Binds the PostHog instance from context to the analytics service so that
 * Lureo events and identify go through the centralised analytics module.
 * Must be rendered inside both PostHogProvider and ServiceProvider.
 */
export function PostHogAnalyticsBinder() {
  const posthog = usePostHog();
  const services = useServices();

  useEffect(() => {
    services.analytics.setPostHog(posthog ?? null);
    // Dev-only: enable PostHog debug logs in console. No effect on staging/production init or tracking.
    if (import.meta.env.DEV && posthog) {
      (posthog as { debug?: (enabled: boolean) => void }).debug?.(true);
    }
    return () => services.analytics.setPostHog(null);
  }, [services.analytics, posthog]);

  return null;
}
